<template>
<ValidationObserver class="col" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomInput
                sm="12"
                vid="subject"
                :name="$t('ticket.subject')"
                rules="required"
                required
                v-model="ticket.subject"
            />

            <CCustomTextarea
                sm="12"
                vid="content"
                :name="$t('ticket.content')"
                rules="required"
                required
                v-model="ticket.content"
            />

            <CCustomSelect
                sm="12" md="4"
                v-model="ticket.category_id"
                :options="selectableCategoriesWithNull"
                vid="category_id"
                required
                rules="required"
                :name="$t('ticket.department')"
            />

            <CCustomSearchableInput
                v-if="$policy('ticket').create_any_or_group"
                sm="12" md="4"
                v-model="createdFor"
                vid="created_for"
                required
                rules="required"
                :name="$t('ticket.created_for')"
                :items="selectableUsers"
            />
        </CRow>

        <CButton :disabled="invalid" type="submit"  color="primary" class="px-4">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Form',

    props: {
        submit: {
            default: function() {},
            required: true,
        },
        ticket: {
            default() {
                return {
                    subject: '',
                    category_id: '',
                    content: '',
                    created_for: ''
                }
            }
        }
    },

    data() {
        return {
            createdFor: ''
        }
    },

    watch: {
        createdFor(val) {
            this.ticket.created_for = val
        }
    },

    computed: {
        ...mapGetters('category', [
            'selectableCategoriesWithNull'
        ]),
        ...mapGetters('user', [
            'selectableUsers'
        ])
    },
}
</script>